export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  newState.pageDataUi = payload

  return newState;
};
